import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Gtag from "@/plugins/gtag";
import { clickoutside } from "./directives/clickoutside";
import { i18n } from "./i18n";
import { captureAttribution } from "@/utils/attribution";

Vue.config.productionTip = false;
Vue.directive("click-outside", clickoutside);
Vue.use(Gtag, {
  config: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    conversion_id: process.env.VUE_APP_GOOGLE_CONVERSION_ID,
    enabled:
      typeof window !== "undefined"
        ? JSON.parse(localStorage.getItem("GDPR-accepted") || "false") || false
        : false
  }
});

// First-touch attribution comes from the landing URL, before in-app navigation
// drops its query. Only business entry pages: customer dashboard and password
// reset links carry personal data in the URL and aren't campaign traffic.
const landingRoute = router.resolve(window.location.pathname).route.name;
if (landingRoute === "Login" || landingRoute === "Register") {
  captureAttribution();
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
